import dayjs from "dayjs";
import inBetween from "dayjs/plugin/isBetween";
import type { UserType } from "@shared/graphql.types";

export const isMember = (user: UserType): boolean => {
  if (user.MembershipStartDate && user.MembershipEndDate) {
    dayjs.extend(inBetween);
    const membershipStartDate = new Date(user.MembershipStartDate);
    const membershipEndDate = new Date(user.MembershipEndDate);
    const currentDate = new Date();
    const isBetween = dayjs(currentDate).isBetween(
      membershipStartDate,
      membershipEndDate
    );
    return isBetween;
  }
  return false;
};

export const calculateAge = (dob: string | undefined): number | undefined => {
  if (!dob) {
    return undefined;
  }

  const dateOfBirth = new Date(dob);
  const currentDate = new Date();
  const date1 = dayjs(currentDate);
  const date2 = dayjs(dateOfBirth);
  const age = date1.diff(date2, "year");
  return age;
};

export function checkOptInTracking(): boolean {
  if (typeof window !== "undefined" && window.OnetrustActiveGroups) {
    return window.OnetrustActiveGroups.includes("C0004");
  }
  return false;
}
